module.exports = __webpack_public_path__ + "img/2.97543212.jpg";